import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Cep } from 'src/app/models/vos/cep.model';


@Injectable({
    providedIn: 'root'
  })
export class CepService {
    baseUrlCep = 'https://viacep.com.br/ws';

    constructor(private http: HttpClient) { }

    getCep(): Observable<Cep[]> {
        return this.http.get<Cep[]>(this.baseUrlCep);
    }

    save(data: any): Observable<any> {
        return this.http.post<any>(this.baseUrlCep, data);
    }

    find(id: any): Observable<any> {
        return this.http.get(`${this.baseUrlCep}/${id}`);
    }

    update(data: any): Observable<any> {
        return this.http.put<any>(this.baseUrlCep, data);
    }

    destroy(id: any): Observable<any> {
        return this.http.delete<any>(`${this.baseUrlCep}?id=${id}`);
    }
    busca_cep(cep: any): Observable<any> {
        return this.http.get(`${this.baseUrlCep}/${cep}/json/`);
    }
}